import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActions = ({
  userRole,
  onCreateProject,
  onInviteMembers,
  onManageUsers,
  onCreateOrganization,
  onCreateAIProject,
  canCreateProjects = true,
  currentProject = null,
  className = ''
}) => {
  const navigate = useNavigate();

  const handleAction = (action) => {
    console.log('Quick action clicked:', action);

    switch (action) {

      case 'view_tasks':
        navigate('/tasks');
        break;
      case 'view_kanban':
        if (currentProject?.id) {
          // Store current project for kanban board
          localStorage.setItem('currentProjectId', currentProject.id);
          localStorage.setItem('currentProject', JSON.stringify(currentProject));
          navigate('/kanban-board', {
            state: {
              projectId: currentProject.id,
              project: currentProject
            }
          });
        } else {
          navigate('/kanban-board');
        }
        break;
      case 'project_settings':
        if (currentProject?.id) {
          navigate(`/project-management?id=${currentProject.id}&tab=settings`);
        } else {
          navigate('/project-management');
        }
        break;
      case 'my_profile':
        navigate('/user-profile-settings');
        break;
      case 'notifications':
        navigate('/notifications');
        break;
      case 'invite_members':
        if (onInviteMembers) {
          onInviteMembers();
        } else {
          navigate('/team-members');
        }
        break;
      case 'manage_users':
        if (onManageUsers) {
          onManageUsers();
        } else {
          navigate('/team-members');
        }
        break;
      case 'create_project':
        if (onCreateProject) {
          onCreateProject();
        } else {
          navigate('/ai-project-creation');
        }
        break;
      case 'create_organization':
        if (onCreateOrganization) {
          onCreateOrganization();
        } else {
          navigate('/organization-settings');
        }
        break;
      case 'create_ai_project':
        if (onCreateAIProject) {
          onCreateAIProject();
        } else {
          navigate('/ai-project-creation');
        }
        break;
      default:
        console.warn('Unknown quick action:', action);
        break;
    }
  };

  // Define role-specific quick actions
  const getMemberActions = () => {
    const actions = [
      {
        label: 'View Tasks',
        action: 'view_tasks',
        variant: 'outline',
        icon: 'CheckSquare',
        description: 'View your assigned tasks'
      },
      {
        label: 'Kanban Board',
        action: 'view_kanban',
        variant: 'outline',
        icon: 'Kanban',
        description: 'Open project board'
      }
    ];

    actions.push(
      {
        label: 'My Profile',
        action: 'my_profile',
        variant: 'ghost',
        icon: 'User',
        description: 'Update profile settings'
      },
      {
        label: 'Notifications',
        action: 'notifications',
        variant: 'ghost',
        icon: 'Bell',
        description: 'View all notifications'
      }
    );

    return actions;
  };





  // Get actions based on user role
  const getActionsForRole = () => {
    // Other roles use Member profile quick actions
    return getMemberActions();
  };

  const actions = getActionsForRole();

  console.log('QuickActions render debug:', { 
    userRole, 
    actionsCount: actions.length, 
    actions: actions.map(a => a.label) 
  });


  return (
    <div className={`group relative bg-white/70 dark:bg-slate-800/60 backdrop-blur-md rounded-2xl border border-white/50 dark:border-slate-700/50 p-6 flex flex-col hover:shadow-xl hover:shadow-slate-200/50 dark:hover:shadow-slate-900/50 transition-all duration-500 ${className} overflow-hidden`}>
      {/* Decorative gradient blob */}
      <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-primary/10 blur-3xl rounded-full group-hover:bg-primary/20 transition-all duration-700"></div>

      <div className="relative flex items-center justify-between mb-6 flex-shrink-0">
        <h3 className="text-xl font-black text-slate-800 dark:text-slate-100 tracking-tightest">Quick Actions</h3>
        <div className="w-10 h-10 bg-primary-light rounded-xl flex items-center justify-center">
          <Icon name="Zap" size={20} className="text-primary" />
        </div>
      </div>

      <div className="relative flex flex-col gap-4 justify-center flex-grow">
        {actions.map((action) => (
          <button
            key={action.action}
            onClick={() => handleAction(action.action)}
            className="group/btn flex items-center gap-4 w-full p-4 rounded-xl bg-white/50 dark:bg-slate-900/40 border border-slate-100 dark:border-slate-700/50 hover:border-primary/50 hover:bg-white dark:hover:bg-slate-900 hover:shadow-md transition-all duration-300 text-left"
          >
            <div className="w-10 h-10 rounded-lg bg-slate-50 dark:bg-slate-800 flex items-center justify-center text-slate-500 group-hover/btn:bg-primary-light group-hover/btn:text-primary transition-colors duration-300">
              <Icon name={action.icon} size={20} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-sm text-slate-800 dark:text-slate-100">{action.label}</div>
              <div className="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5 truncate uppercase tracking-wider font-semibold">
                {action.description}
              </div>
            </div>
            <Icon name="ChevronRight" size={16} className="text-slate-300 group-hover/btn:text-primary transform translate-x-0 group-hover/btn:translate-x-1 transition-all" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
